import React from 'react';
import '../scss/Home.scss';
import ImageCarousel from './ImageCarousel';
import ActiveCampaign from './ActiveCampaign';
import AboutUs from './AboutUs';
import '../scss/responsive.scss';
import Benefits from './Benefits';  
import Catalogs from './Catalogs'

const Home: React.FC = () => {
  return (
    <main className="home-main">
      <ImageCarousel />
      <Benefits />                      
      <ActiveCampaign />
      <Catalogs />
      <AboutUs />
    </main>
  );
};

export default Home;
